<template>
  <div>

    <a-badge :count="officeCount"
             :title="`Aantal kantoren onder regio: ${region.name}`"
             :number-style="{ backgroundColor: color.primary }"/>

    <a-popover :title="`Regio: ${region.name}`" trigger="click hover" placement="leftTop">
      <template slot="content">
        <a-popconfirm
            :title="`Weet u zeker dat u deze regio (${region.name}) wilt verwijderen?`"
            ok-text="Ja"
            cancel-text="Annuleer"
            @confirm="confirmedDelete(region.id)"
        >
          <a-button type="danger" :loading="loading">
            <delete-icon/>
            Verwijderen
          </a-button>
        </a-popconfirm>
        <a-button type="primary" @click="edit(region.id)">
          <pencil-icon/>
          Bewerken
        </a-button>
      </template>
      <a-button shape="round" size="small" :class="{ loading: loading }">
        <!--        <dots-vertical-icon></dots-vertical-icon>-->
        <cog-icon></cog-icon>
      </a-button>
    </a-popover>

  </div>
</template>

<script>
import regionApi from '~/api/region';

export default {
  name: "RegionHelperComponent",
  props: {
    region: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      color: {
        primary: '#1890ff'
      },
      loading: false,
    }
  },
  computed: {
    officeCount() {
      let count = 0,
          countDescendants = 0;

      if (this.region.offices.data.length) {
        count = this.region.offices.data.length;
      }

      if ('descendants' in this.region) {
        if (this.region.descendants.data.length) {
          this.region.descendants.data.forEach(descendant => {
            countDescendants += descendant.offices.data.length;
          })
        }
      }

      return count + countDescendants;
    }
  },
  methods: {
    edit(regionId) {
      window.location.href = `/settings/organization/region/${regionId}/edit`;
    },
    confirmedDelete(regionId) {
      this.loading = true;
      regionApi.delete(regionId)
          .then(() => {
            this.$notification['success']({
              message: 'Success',
              description: 'De regio is verwijderd',
            });
            this.$emit('deleted-region', regionId);
          })
          .catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt de regio te verwijderen',
            })
          })
          .finally(() => {
            this.loading = false;
          });
    },
  }
}
</script>

<style scoped>
.loading {
  opacity: .5;
}
</style>